import { observer } from "mobx-react-lite";
import { ReactElement } from "react";
import { Center, Flex, FlexProps, Spacer, Text } from "@chakra-ui/react";

import { isString } from "@noli/core";

import { themeStore } from "@/stores/theme";
import IconButton, { IIconButton } from "@/components/IconButton";

export interface ISubPanel extends FlexProps {
  panelTitle?: string | ReactElement;
}

function SubPanel({ panelTitle, children, ...others }: ISubPanel) {
  const { titleColor } = themeStore.styles;

  let title;
  if (!panelTitle) {
    title = null;
  } else if (isString(panelTitle)) {
    title = (
      <Text
        px="16px"
        mb="8px"
        color={titleColor}
        fontSize="12px"
        fontWeight={700}
        userSelect="none"
      >
        {panelTitle}
      </Text>
    );
  } else {
    title = panelTitle;
  }
  return (
    <Flex w="100%" direction="column" align="start" {...others}>
      {title}
      {children}
    </Flex>
  );
}

interface ISubPanelTitleWithSubTitle extends FlexProps {
  title: string;
  subTitle?: ReactElement | ReactElement[] | null;
}
export const SubPanelTitleWithSubTitle = observer<ISubPanelTitleWithSubTitle>(
  ({ title, subTitle, ...others }) => {
    const { titleColor } = themeStore.styles;

    return (
      <Flex w="100%" h="18px" {...others}>
        <Center px="16px" color={titleColor} fontSize="12px" fontWeight={700} userSelect="none">
          {title}
        </Center>
        <Spacer />
        {subTitle}
      </Flex>
    );
  },
);

interface ISubPanelTitleWithIcon extends FlexProps {
  title: string;
  icon?: IIconButton["icon"];
  onIconClick?: () => void;
  iconProps?: Partial<IIconButton>;
  customIcons?: ReactElement[];
}
export const SubPanelTitleWithIcon = observer<ISubPanelTitleWithIcon>(
  ({ title, icon, onIconClick, iconProps, customIcons, ...others }) => {
    const titleIcon =
      customIcons ??
      (icon ? (
        <Center>
          <IconButton mr="8px" icon={icon} onClick={onIconClick} {...(iconProps ?? {})} />
        </Center>
      ) : null);

    return <SubPanelTitleWithSubTitle title={title} subTitle={titleIcon} {...others} />;
  },
);

export default observer(SubPanel);
